import {UIModeSelectorDetailsController, StartGameCallback, SelectModeCallback} from '../../../../shared/scripts/ui_html/home_page/UIModeSelectorDetailsController'

export class UIWModeSelectorDetailsController extends UIModeSelectorDetailsController {
    private readonly modeSelectorContainer: HTMLDivElement

    constructor(onStartGame: StartGameCallback, onSelectMode?: SelectModeCallback) {
        super(onStartGame, onSelectMode)
        this.modeSelectorContainer = document.getElementById('mm-mode-selector-container') as HTMLDivElement
    }

    protected onShow() {
        this.modeSelectorContainer.classList.add('hidden')
    }

    protected onHide() {
        this.modeSelectorContainer.classList.remove('hidden')
    }
}

